module.exports = __webpack_public_path__ + "img/skrehendelser-tid.cfbf62fb.jpg";